import { produce } from 'immer';

import { ILogDetails } from '../ingestion.interface';
import { TREE_ID_PREFIXES, splitChar } from './treeId.constants';

export const setTreeIds = (logDetails: ILogDetails) => {
  const nextState = produce(logDetails, (draftState) => {
    const ingestionId = draftState.ingestionId;
    const BASE_TREE_ID = `${TREE_ID_PREFIXES.splitChar}${ingestionId}`;

    draftState.treeId = `${TREE_ID_PREFIXES.root}${ingestionId}`;

    if (draftState.tripples) {
      const BASE_TRIPPLES_ID = `${TREE_ID_PREFIXES.tripples}${BASE_TREE_ID}`;
      draftState.tripples.treeId = BASE_TRIPPLES_ID;

      // tripples level
      if (draftState.tripples.dataSources) {
        draftState.tripples.dataSources = draftState.tripples.dataSources.map((ds, dsIndex) => {
          const BASE_DS_ID = `${TREE_ID_PREFIXES.dataSource}${dsIndex}${BASE_TREE_ID}`;

          return {
            ...ds,
            treeId: BASE_DS_ID,

            files: ds.files?.map((file, fileIndex) => {
              const BASE_FILE_ID = `${TREE_ID_PREFIXES.table}${fileIndex}${splitChar}${dsIndex}${BASE_TREE_ID}`;

              return {
                ...file,
                treeId: BASE_FILE_ID,

                files: file.files?.map((fileLeaf, leafIndex) => {
                  const BASE_LEAF_ID = `${TREE_ID_PREFIXES.segment}${leafIndex}${splitChar}${fileIndex}${splitChar}${dsIndex}${BASE_TREE_ID}`;
                  return {
                    ...fileLeaf,
                    treeId: BASE_LEAF_ID,
                  };
                }),
              };
            }),

            tables: ds.tables?.map((table, tableIndex) => {
              const BASE_TABLE_ID = `${TREE_ID_PREFIXES.tables}${tableIndex}${splitChar}${dsIndex}${BASE_TREE_ID}`;
              return {
                ...table,
                treeId: BASE_TABLE_ID,
              };
            }),
          };
        });
      }
    }

    // timeseries level
    if (draftState.timeseries) {
      const BASE_TIMESERIES_ID = `${TREE_ID_PREFIXES.timeseries}${BASE_TREE_ID}`;
      draftState.timeseries.treeId = BASE_TIMESERIES_ID;

      if (draftState.timeseries.dataSources) {
        draftState.timeseries.dataSources = draftState.timeseries.dataSources.map((ds, dsIndex) => {
          const BASE_DS_ID = `${TREE_ID_PREFIXES.ts}${TREE_ID_PREFIXES.dataSource}${dsIndex}${BASE_TREE_ID}`;

          return {
            ...ds,
            treeId: BASE_DS_ID,

            tables: ds.tables?.map((table, tableIndex) => {
              const BASE_TABLE_ID = `${TREE_ID_PREFIXES.ts}${TREE_ID_PREFIXES.tables}${tableIndex}${splitChar}${dsIndex}${BASE_TREE_ID}`;
              return {
                ...table,
                treeId: BASE_TABLE_ID,
              };
            }),

            files: ds.files?.map((file, fileIndex) => {
              const BASE_FILE_ID = `${TREE_ID_PREFIXES.ts}${TREE_ID_PREFIXES.table}${fileIndex}${splitChar}${dsIndex}${BASE_TREE_ID}`;
              return {
                ...file,
                treeId: BASE_FILE_ID,

                files: file.files?.map((fileLeaf, leafIndex) => {
                  const BASE_LEAF_ID = `${TREE_ID_PREFIXES.ts}${TREE_ID_PREFIXES.segment}${leafIndex}${splitChar}${fileIndex}${splitChar}${dsIndex}${BASE_TREE_ID}`;
                  return {
                    ...fileLeaf,
                    treeId: BASE_LEAF_ID,
                  };
                }),
              };
            }),
          };
        });
      }
    }
  });

  return nextState;
};
